import { Spinner } from "reactstrap";

const VARIANTS = {
  idle: null,
  pending: { color: "text-muted", icon: <i className="fas fa-pen" />, label: "Editing…" },
  saving: { color: "text-primary", icon: <Spinner size="sm" />, label: "Saving…" },
  saved: { color: "text-success", icon: <i className="fas fa-check-circle" />, label: "Saved" },
  error: { color: "text-danger", icon: <i className="fas fa-exclamation-triangle" />, label: "Save failed" },
};

export default function SaveStatusBadge({ status }) {
  const variant = VARIANTS[status];
  if (!variant) return null;
  return (
    <small className={`d-inline-flex align-items-center ${variant.color}`} aria-live="polite">
      {variant.icon}
      <span className="ml-1">{variant.label}</span>
    </small>
  );
}
